import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { BookingStatusEnum } from 'src/app/shared/models/booking-status.enum';
import { BookingService } from '../../../services/booking.service';
import moment from 'moment';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
    selector: 'booking-quickview-modal',
    templateUrl: './booking-quickview-modal.component.html',
    styleUrl: './booking-quickview-modal.component.scss',
    standalone: false
})
export class BookingQuickviewModalComponent extends BaseModalComponent implements OnInit {
  booking: any;
  BookingStatus = BookingStatusEnum;
  bookingAddons: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<BookingQuickviewModalComponent>,
    private bookingService: BookingService,
    private sessionService: SessionService
  ) {
    super();
  }

  ngOnInit() {
    this.getBookingAddons();
  }

  getBookingAddons() {
    if (this.booking?.id) {
      this.isLoading = true;
      this.bookingService.getAddons(this.booking.id).subscribe({
        next: (result) => {
          this.booking.addons = result;
          this.isLoading = false;
        },
        error: (error) => {
          console.error(error);
          this.isLoading = false;
        }
      });
    }
  }

  calculateDuration(): number {
    if (this.booking?.startTime && this.booking?.endTime) {
      const start = new Date(this.booking.startTime);
      const end = new Date(this.booking.endTime);
      const diffInHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
      return Math.round(diffInHours);
    }
    return 0;
  }

  getFinalAmount(): number {
    if (!this.booking) return 0;
    return this.booking.refundAmount ? 
      this.booking.totalPrice - this.booking.refundAmount : 
      this.booking.totalPrice;
  }

  formatInUserTimezone(date: Date, format: string): string {
    return moment.utc(date).tz(this.sessionService.getUser().timeZone).format(format);
  }
}
